import HttpService from './httpService';
import config from '../../config';

class LoginApiService extends HttpService {
  async auth({ tokenId, profileObj }) {
    return this.post('auth', { tokenId, profileObj });
  }

  async verifyToken() {
    return this.get('verifyToken');
  }
}

const loginApiService = new LoginApiService(config.REACT_APP_NODE_API);
export default loginApiService;
